import axios from "axios";
import {
  TEACHER_PAYMENT_ALL_ACTIONS_TYPE,
  TEACHERS_PAYMENTS_MODAL_ACTION_TYPE,
} from "../actions-type";
import { apiRoot } from "../../apiRoot";
import { logoutAction } from "./auth";
import { toast } from "react-toastify";

const API = axios.create({
  baseURL: `${apiRoot}/user/teacher`,
  withCredentials: true,
});

const refreshApi = axios.create({
  baseURL: `${apiRoot}/user/auth/refresh_token`,
  withCredentials: true,
});

const REGISTERAPI = axios.create({
  baseURL: `${apiRoot}/user/auth`,
  withCredentials: true,
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

REGISTERAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

const setLoadingTeacherpaymentAction = (loadingValue) => ({
  type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.TEACHER_PAYMENT_LOADING,
  payload: loadingValue,
});

const modalLoading = (loadingValue) => ({
  type: TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.TEACHER_PAYMENT_MODAL_LOADING,
  payload: loadingValue,
});

const toastSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

export const getTeachersSalaries =
  (role, startDate, endDate) => async (dispatch) => {
    console.log(startDate, "startdate");
    console.log(endDate, "edn date");
    try {
      const { data } = await API.get(
        `/salaries/?role=${role}&startDate=${startDate}&endDate=${endDate}`
      );

      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.GET_TEACHERS_SALARIES,
        payload: data,
      });
    } catch (error) {
      console.log(error);
    }
  };

export const getTeachersPaymentsPaginationAction =
  (length, searchQuery, status = "all", role, courseId) =>
  async (dispatch) => {
    console.log(length);
    dispatch(setLoadingTeacherpaymentAction(true));
    try {
      const { data } = await API.get(
        `/pagination/?length=${length}&searchQuery=${searchQuery}&status=${status}&role=${role}&courseId=${
          courseId || ""
        }`
      );
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.GET_TEACHER_PAYMENT_PAGINATION,
        payload: data,
      });
    } catch (error) {
      console.log(error);
      const originalRequest = error.config;
      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const token = await refreshApi.get("/");
          localStorage.setItem(
            "auth",
            JSON.stringify({
              AccessToken: token.data.accesstoken,
            })
          );
          const { data } = await API.get(
            `/pagination/?length=${length}&searchQuery=${searchQuery}&status=${status}&role=${role}&courseId=${
              courseId || ""
            }`
          );

          dispatch({
            type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.GET_TEACHER_PAYMENT_PAGINATION,
            payload: data,
          });
        } catch (error) {
          // // console.log(error);
          if (error?.response?.status === 401) {
            return dispatch(logoutAction());
          }
        }
      }
    } finally {
      dispatch(setLoadingTeacherpaymentAction(false));
    }
  };

export const updateTeacherPaymentAction =
  (_id, teacherData) => async (dispatch) => {
    dispatch(modalLoading(true));
    try {
      const { data } = await API.patch(`/teacher-salary/${_id}`, teacherData);
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.UPDATE_TEACHER_PAYMENT,
        payload: data,
      });
      dispatch({
        type: TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.TEACHER_PAYMENT_OPEN_MODAL,
        payload: false,
      });
      toastSuccess("Təlimçi yeniləndi");
    } catch (error) {
      const originalRequest = error.config;
      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const token = await refreshApi.get("/");
          localStorage.setItem(
            "auth",
            JSON.stringify({
              AccessToken: token.data.accesstoken,
            })
          );
          const { data } = await API.patch(`/${_id}`, teacherData);
          dispatch({
            type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.UPDATE_TEACHER_PAYMENT,
            payload: data,
          });
          dispatch({
            type: TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.TEACHER_PAYMENT_OPEN_MODAL,

            payload: false,
          });
          toastSuccess("Təlimçi yeniləndi");
        } catch (error) {
          if (error?.response?.status === 401) {
            return dispatch(logoutAction());
          }
        }
      }
    } finally {
      dispatch(modalLoading(false));
    }
  };
